import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import { spreedlyCredentialsApiMiddleware, wishlistsApi, vibesApi } from "@capone/common";
import { rootReducer } from "../reducers";
import { rootSaga } from "../sagas";

// REDUX SAGA middleware
export const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(
      sagaMiddleware,
      wishlistsApi.middleware,
      spreedlyCredentialsApiMiddleware,
      vibesApi.middleware
    ),
  devTools: process.env.NODE_ENV !== "production" && {
    trace: true,
    traceLimit: 25,
  },
});

sagaMiddleware.run(rootSaga);
